import { ActionReducerMap } from '@ngrx/store';
import { configReducer } from './configuration/config.reducer';
import { tokenReducer } from './configuration/token.reducer';
import { batchStatusReducer } from './scanner/batchStatus.reducer';
import { scannerStatusReducer } from './scanner/scannerStatus.reducer';
import { scansReducer } from './scanner/scans.reducer';
import { sessionReducer } from './session/session.reducer';
import { siteInformationReducer } from './configuration/site-information.reducer';
import { resultsReducer } from './session/results.reducer';
import { policyReducer } from './policy/policy.reducer';
import { userReducer } from './configuration/user.reducer';
import { pollingReducer } from './polling/polling.reducer';
import { diagnosticsReducer } from './diagnostics/diagnostics.reducer';

export const reducers: ActionReducerMap<any> = {
  config: configReducer,
  siteInformation: siteInformationReducer,
  token: tokenReducer,
  user: userReducer,
  diagnostics: diagnosticsReducer,
  scannerStatus: scannerStatusReducer,
  batchStatus: batchStatusReducer,
  scans: scansReducer,
  session: sessionReducer,
  results: resultsReducer,
  policy: policyReducer,
  polling: pollingReducer,
};
